<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $t("supportticketcategory") }}
      </div>
      <div>
        <router-link
          v-if="$can('update', 'Support Ticket Category')"
          class="btn-blue"
          @click.native="goToRoute('/master/edit-support-ticket-category')"
          to
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="/master/support-ticket-category"
          >{{ $t("supportticketcategory") }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">
            {{ $tc("category", 1) }} {{ $t("name") }}
          </div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span class="mr-3"></span>
            <span class="mr-3">{{ category_name }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc("status", 1) }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span class="mr-3"></span>
            <span v-if="category_is_active == 'Y'" class="mr-3">Active</span>
            <span v-else class="mr-3">Inactive</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("createdat") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3"></span>
            <span class="mr-3">{{ created_at | dateparse }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("createdby") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3"></span>
            <span class="mr-3">{{ userDetails.created_by }}</span>
          </div>
        </div>
      </div>

      <div v-if="login_user_role_id === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("updatedat") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3"></span>
            <span class="mr-3">{{ updated_at | dateparse }}</span>
          </div>
        </div>
      </div>

      <div v-if="login_user_role_id === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("updatedby") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3"></span>
            <span class="mr-3">{{ userDetails.updated_by }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      stc_id: null,
      submitted: false,
      category_name: null,
      category_is_active: "",
      login_user_role_id: null,
      created_at: "",
      updated_at: "",
      userDetails: [],
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    this.stc_id = this.$route.query.stc_id;
    this.login_user_role_id = this.secureStore.get("USINFO").role_id;

    if (this.stc_id) {
      this.GetSupportTicketCategory();
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    goToRoute: function (path) {
      this.$router.push({
        path: path,
        query: {
          stc_id: this.stc_id,
        },
      });
    },
    GetSupportTicketCategory: function () {
      let payload = {
        stc_id: this.stc_id,
      };
      let loader = this.$loading.show();

      MasterService.GetCategory(payload)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.category_name = data.Records[0].stc_name;
              this.category_is_active = data.Records[0].stc_is_active;

              this.created_at = data.Records[0].created_at;
              this.updated_at = data.Records[0].updated_at;

              this.getViewUsersDetails(
                data.Records[0].created_by,
                "created_by"
              );
              this.getViewUsersDetails(
                data.Records[0].updated_by,
                "updated_by"
              );
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    getViewUsersDetails(user_id, key) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.userDetails[key] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/SupportTicketCategoryComponents/viewSupportTicketCategory.vue